import { useEffect } from 'react';

const ariaHiddenAttribute = 'aria-hidden';

/**
 * To make sure screen readers don't read the content behind a modal
 * We must hide it from them.
 */
export const useHidePageMainContentForAccessibility = modalIsOpen => {
  useEffect(() => {
    const pageContent = document.getElementById('__next');
    if (modalIsOpen) {
      if (!pageContent?.hasAttribute(ariaHiddenAttribute)) {
        pageContent.setAttribute(ariaHiddenAttribute, 'true');
      }
    } else if (pageContent?.hasAttribute(ariaHiddenAttribute)) {
      pageContent.removeAttribute(ariaHiddenAttribute);
    }
  }, [modalIsOpen]);
};
